import {FC, memo, useEffect, useState} from 'react';
import {IntlShape} from 'react-intl';
import {Alert} from '@baidu/luffy-comp-alert';
import {getUrlParams} from '@/utils/kuQuery';

import {EDITOR_MODE} from '@/Constant';
import {SQUARE_VISIT_STATUS} from '@/constants/document/square';

import styles from './index.module.scss';
import KU_QUERY from '@/constants/common/searchParamKeys';

interface SquareEditAlertProps {
    intl: IntlShape;
    mode: EDITOR_MODE;
}

export const SquareEditAlert: FC<SquareEditAlertProps> = memo(props => {
    const {intl, mode} = props;

    // 来源
    const [from, setFrom] = useState(getUrlParams(KU_QUERY.space.from));

    // 之前是否有展示过
    const [noShow] = useState(!localStorage.getItem(SQUARE_VISIT_STATUS.FIRST_EDIT_STATUS));

    // 是否是编辑状态
    const isEditStatus = mode === EDITOR_MODE.edit;

    useEffect(() => {
        const from = getUrlParams(KU_QUERY.space.from);

        setFrom(from);
        // 如果有来源，就设置来源
        if (isEditStatus && from === 'square') {
            // 只要访问过之后，就不再展示
            localStorage.setItem(SQUARE_VISIT_STATUS.FIRST_EDIT_STATUS, '1');
        }
    }, [isEditStatus]);

    // 1. 来自知识广场 2.编辑状态下 3. 没展示过并且从没展示过的。
    const show = from === 'square' && isEditStatus && noShow;

    if (!show) {
        return null;
    }

    return (
        <Alert
            className={styles.squareEditAlert}
            content={intl.formatMessage({id: 'editStatusFirstEntrySquare'})}
            closable
        />
    );
});
